import useApi from '../hook/useApi';

const useHistoryApi = () => {
    const { sendRequest, loading, data, error } = useApi();

    const getRevenueHistory = async (page = 1, transactionType = "", start_date = "", end_date = "") => {
        let queryParams = [`page=${page}`, `limit=10`];

        if (transactionType) {
            queryParams.push(`transactionType=${encodeURIComponent(transactionType)}`);
        }

        if (start_date && end_date) {
            queryParams.push(`start_date=${start_date}`);
            queryParams.push(`end_date=${end_date}`);
        }

        const queryString = queryParams.join('&');
        return sendRequest(`/imp/dashboard_screen/get_revenue_history?${queryString}`, 'GET', {});
    };

    return {
        getRevenueHistory,
        loading,
        data,
        error,
    };
};

export default useHistoryApi;